module.exports = __webpack_public_path__ + "media/images/illustrations/mover_waving_small-f84b9ee32220f8825d581342393807f4.svg";